var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-page-container"},[_c('div',{staticClass:"not-found-page"},[_c('success-failure-display',{attrs:{"error":"","message":"Seite nicht gefunden"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }